"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipDeadline = void 0;
/**
 * Ship deadline in days for different fulfillment types
 */
var ShipDeadline;
(function (ShipDeadline) {
    ShipDeadline[ShipDeadline["BrandDirect"] = 14] = "BrandDirect";
    ShipDeadline[ShipDeadline["TradeIn"] = 14] = "TradeIn";
    ShipDeadline[ShipDeadline["Default"] = 7] = "Default";
})(ShipDeadline || (exports.ShipDeadline = ShipDeadline = {}));
